import { UsagePermissionsInfo } from '../../components/usagePermissions/types'
import { UsagePermissionsState } from '../reducers/initialState'

import * as types from './actionTypes'
import { BaseActionType } from './actionTypes'

export const loadUsagePermissionsSuccess = (
  usagePermissions: UsagePermissionsState,
): BaseActionType => ({
  type: types.LOAD_USAGE_PERMISSIONS_SUCCESS,
  payload: usagePermissions,
})

export const loadMoreUsagePermissionsSuccess = (
  usagePermissions: UsagePermissionsState,
): BaseActionType => ({
  type: types.LOAD_MORE_USAGE_PERMISSIONS_SUCCESS,
  payload: usagePermissions,
})

export const addUsagePermissionSuccess = (
  usagePermission: UsagePermissionsInfo,
): BaseActionType => ({
  type: types.ADD_USAGE_PERMISSIONS_SUCCESS,
  payload: usagePermission,
})

export const deleteUsagePermissionSuccess = (
  usagePermission: UsagePermissionsInfo,
): BaseActionType => ({
  type: types.DELETE_USAGE_PERMISSIONS_SUCCESS,
  payload: usagePermission,
})

export const updateUsagePermissionSuccess = (
  usagePermission: UsagePermissionsInfo,
): BaseActionType => ({
  type: types.UPDATE_USAGE_PERMISSIONS_SUCCESS,
  payload: usagePermission,
})
